import routes from '@modules/stripe/stripe-income/stripe-income-routes.js';
import store from '@modules/stripe/stripe-income/stripe-income-store.js';

export default {
  routes,
  store
};
